import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ImageProgressBar from './ImageProgressBar';
import abortedIcon from '../img/aborted.png';
import processingIcon from '../img/processing.gif';
import {getUploadingFilePreview} from '../reducers/uploadingFilePreviews';
import {Button, ButtonToolbar} from 'react-bootstrap';

export default class ProcessingImagePreview extends Component {
    static propTypes = {
        srcPrefix: PropTypes.string,
        image: PropTypes.object,
        onDelete: PropTypes.func,
        onRetry: PropTypes.func,
    };

    handleDelete = () => {
        this.props.onDelete(this.props.image);
    };

    handleRetry = () => {
        this.props.onRetry(this.props.image);
    };

    render() {
        const {image, srcPrefix, onDelete, onRetry} = this.props;

        if (!image) {
            return false;
        }

        const {status, error, uploadId, poppingPct, uploadFinished} = image;
        const badgeStyle = {position: 'absolute', top: 0, left: 0};
        let badgeControl;
        const isError = error || (status === 'ABORTED') || (status === 'ERROR');

        if (isError) {
            badgeControl = <img className="badge-icon" src={abortedIcon} title={error} style={badgeStyle} alt="aborted"/>;
        } else if (status === 'SUCCESS') {
            badgeControl = null;
        } else if (poppingPct <= 100) {
            // upload started
            badgeControl = <img className="badge-icon" src={processingIcon} style={badgeStyle} alt="processing"/>;
        }
        let previewSrc = (srcPrefix || '') + image.previewSrc;
        if (!uploadFinished || poppingPct <= 0) {
            const uploadingFilePreview = getUploadingFilePreview(uploadId);
            if (uploadingFilePreview) {
                previewSrc = uploadingFilePreview;
            }
        }
        const controlsRow = (
            <ButtonToolbar className="controls">
                <Button bsStyle="primary" bsSize="xsmall" onClick={this.handleRetry} title="Retry" block disabled={!isError || !onRetry}>{'Retry '}<i className="fa fa-refresh"/></Button>
                <Button bsStyle="danger" bsSize="xsmall" onClick={this.handleDelete} title="Delete" block disabled={!isError || !onDelete}>{'Delete '}<i className="fa fa-trash"/></Button>
            </ButtonToolbar>
        );

        return (
            <div className="processing-preview">
                <div title={image.filename} className="processing-filename"><h5 className="editorFileName">{image.fileName}</h5></div>
                <div className="thumb">
                    <img className="preview" src={previewSrc} crossOrigin="use-credentials" onClick={this.handleClick} alt="preview"/>
                    {badgeControl}
                </div>
                {controlsRow}
                <div className="processing-progress"><ImageProgressBar imageInfo={image}/></div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ProcessingImagePreview.js